/**
 * Country list with default currency for each.
 * Used by Suppliers (country dropdown + auto-currency).
 * Keep alphabetical except for Bahrain pinned to top (most common for this CRM).
 */
export const COUNTRIES = [
  { name: 'Bahrain', currency: 'BHD' },
  { name: 'Australia', currency: 'AUD' },
  { name: 'Bangladesh', currency: 'BDT' },
  { name: 'Belgium', currency: 'EUR' },
  { name: 'Canada', currency: 'CAD' },
  { name: 'China', currency: 'CNY' },
  { name: 'Egypt', currency: 'EGP' },
  { name: 'France', currency: 'EUR' },
  { name: 'Germany', currency: 'EUR' },
  { name: 'Greece', currency: 'EUR' },
  { name: 'Hong Kong', currency: 'HKD' },
  { name: 'India', currency: 'INR' },
  { name: 'Indonesia', currency: 'IDR' },
  { name: 'Iran', currency: 'IRR' },
  { name: 'Iraq', currency: 'IQD' },
  { name: 'Italy', currency: 'EUR' },
  { name: 'Japan', currency: 'JPY' },
  { name: 'Jordan', currency: 'JOD' },
  { name: 'Kenya', currency: 'KES' },
  { name: 'Kuwait', currency: 'KWD' },
  { name: 'Lebanon', currency: 'LBP' },
  { name: 'Malaysia', currency: 'MYR' },
  { name: 'Netherlands', currency: 'EUR' },
  { name: 'Oman', currency: 'OMR' },
  { name: 'Pakistan', currency: 'PKR' },
  { name: 'Philippines', currency: 'PHP' },
  { name: 'Qatar', currency: 'QAR' },
  { name: 'Russia', currency: 'RUB' },
  { name: 'Saudi Arabia', currency: 'SAR' },
  { name: 'Singapore', currency: 'SGD' },
  { name: 'South Africa', currency: 'ZAR' },
  { name: 'South Korea', currency: 'KRW' },
  { name: 'Spain', currency: 'EUR' },
  { name: 'Sri Lanka', currency: 'LKR' },
  { name: 'Sweden', currency: 'SEK' },
  { name: 'Switzerland', currency: 'CHF' },
  { name: 'Taiwan', currency: 'TWD' },
  { name: 'Thailand', currency: 'THB' },
  { name: 'Turkey', currency: 'TRY' },
  { name: 'UAE', currency: 'AED' },
  { name: 'UK', currency: 'GBP' },
  { name: 'USA', currency: 'USD' },
  { name: 'Vietnam', currency: 'VND' },
  { name: 'Yemen', currency: 'YER' },
  { name: 'Other', currency: 'USD' },
];

/** Look up the default currency for a country name (case-insensitive). */
export const currencyForCountry = (countryName) => {
  if (!countryName) return 'BHD';
  const match = COUNTRIES.find(
    (c) => c.name.toLowerCase() === String(countryName).trim().toLowerCase()
  );
  return match ? match.currency : 'USD';
};
